import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '@/store/store'
import { errorMessageMapping } from '@/helpers/message-mapping'
import routes from '@/routes/routes'
import getLocaleFromUrl from '@ui/shared-utils/src/getLocaleFromUrl'
import { track } from '@/services/tracking'
import { getRouteWithRestoredRedirect } from '@/helpers/auth-utils'

const queryParamsToRemove = ['code', 'state']
const canonicalPaths = ['/login', '/register', '/forgot-password']

Vue.use(VueRouter)

// We cannot retrieve from store as this would introduce dependency issues
const { urlPrefix } = getLocaleFromUrl(window.location)
const Router = new VueRouter({ mode: 'history', base: `${urlPrefix}/auth`, routes })

function hasQueryParams (route) {
  return !!Object.keys(route.query).length
}

Router.beforeEach(async (to, from, next) => {
  window.scrollTo(0, 0)

  if (canonicalPaths.includes(to.path)) {
    const prefix = urlPrefix ? '/uk' : ''
    store.dispatch('site/setPath', `${prefix}/auth${to.path}`)
  } else {
    store.dispatch('site/setPath', '')
  }

  if (from &&
    store.getters['site/message'] &&
    from.name !== 'request-password' &&
    from.name !== 'email-verification') {
    store.dispatch('site/clearMessage')
  }

  let routeWithRestoredRedirect = null
  // Check for error query params from Cognito and display appropriate error message
  if (to.query && to.query.error === 'invalid_request') {
    const errorMessage = errorMessageMapping(to.query.error_description)

    store.dispatch('site/setMessage', { message: errorMessage, type: 'danger' })
    track({ name: 'failed', params: { name: 'login', error_message: errorMessage } })

    // This solves losing our redirect URL when the Cognito flow redirects back with errors
    routeWithRestoredRedirect = getRouteWithRestoredRedirect(to)
  }

  // Stop single use query params from persisting
  queryParamsToRemove.forEach(queryParam => delete from.query[queryParam])

  if (routeWithRestoredRedirect) {
    return next(routeWithRestoredRedirect)
  }

  if (!hasQueryParams(to) && hasQueryParams(from)) {
    return next({
      name: to.name,
      query: from.query
    })
  }
  return next()
})

export default Router
